<template>
<LoderInfo :load="load"></LoderInfo>

<SideBar :activemode="activeClass"></SideBar>

<div :class="main_wrapper">
  <HeaderDashboard @send="changeActiveMode"></HeaderDashboard>
  <div class="main_wrapper_b">
    <section class="bread_cum">
      <div class="container-fluid">
        <div class="row justify-content-end">

          <div class="col-lg-6">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <router-link to="/dashboard"><i class="fa-thin fa-grid me-1"></i> Dashboard</router-link>
                </li>
                <li class="breadcrumb-item text-white"> <i class="fa-sharp fa-solid fa-dollar-sign"></i> Currencies</li>
            

              </ol>
            </nav>
          </div>
        </div>

      </div>
    </section>

<section class="m-lg-3">
  <section class="table-sec  rounded-2 mb-5 p-">

<div class="container-fluid ">
  <div class="row justify-content-center bg-light py-2 set_radius">
    <div class="col-lg-6 text-center ">
      <HeadingTitle title="Available Currencies "></HeadingTitle>
    </div>
  </div>
</div>
<div class="container-fluid p-4 ">
  <div class="row enteries-row align-items-center mb-5">
    <!-- <div class="col-xl-6 col-lg-6 col-md-6">
      <div class="entry-box ">
        <h5>Show</h5>
        <span>
          <select class="select" v-model="limit" v-on:change="getMoreResults">
            <option
              v-for="(option, index) in options"
              :key="index"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>
        </span>

        <h6>enteries</h6>
      </div>
    </div> -->

    <!--col-xl-6 col-lg-6 col-md-6-->

    <!-- <div class="col-xl-6 col-lg-6 col-md-6">
      <div class="search-box">
        <div class="input-group">
          <span class="input-group-text" id="basic-addon1"><img src="../assets/images/search.svg" alt="" class="img-fluid"></span>
          <input type="text" class="form-control" placeholder="Search....." aria-label="Username" aria-describedby="basic-addon1">
        </div>
      </div>
    </div> -->
  </div>
  <!--row enteries-row-->

  <div class="row table-row">
    <div class="col-xl-12 col-lg-12 col-md-12">
      <div class="table-responsive">
        <table class="table table-bordered ">
          <thead>
            <tr>
              <th scope="col" class="fw-bold" style="width:40%">Currency</th>
              <th scope="col" class="fw-bold">Status <span><img src="../../assets/images/table_icon_2.png" alt="" class="img-fluid"></span></th>
              <th scope="col" class="fw-bold">Action </th>

            </tr>
          </thead>
          <tbody v-if="currencies.length">
            <tr v-for="(currency, index) in currencies" :key="index">
              <td>{{ currency.name.toUpperCase() }}</td>
              <td> <span :class="currency.status ? 'badge bg-success': 'badge bg-danger'">{{ currency.status ? 'Active': 'Inactive'}} </span></td>
              <td> 
                <button type="button" :class="currency.status ? 'unBlock_user mx-3': 'change_wallet mx-3'" @click="enableDisableCurrency(currency.id)">
                  {{ currency.status ? 'Disable': 'Enable'}}
                </button>
               </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="5">No Data Available</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--table-responsive-->
    </div>
    <!--col-xl-12 col-lg-12 col-md-12-->
  </div>

</div>

</section>
</section>

  </div>
  <FooterDetail></FooterDetail>
</div>
</template>

  
<script>
import HeadingTitle from "@/components/HeadingTitle.vue";
import SideBar from "@/components/SideBar.vue";
import HeaderDashboard from "@/components/HeaderDashboard.vue";
import FooterDetail from "@/components/FooterDetail.vue";
import LoderInfo from "@/components/LoderInfo.vue";

export default {
  name: "AdminCurrencies",
  // props: ['main_wrapper'],
  components: {
    SideBar,
    HeaderDashboard,
    HeadingTitle,
    FooterDetail,
    LoderInfo
  },
  data() {
    return {
      activeClass: 'sidebar',
      main_wrapper: 'main_wrapper',
      currencies: [] ,
    }
  },
  methods: {
    dateFormate(date){
      let cur_date = new Date(date);
      cur_date.setTime(cur_date.getTime() + 19800000)
      cur_date = cur_date.toISOString()
      return cur_date.substr(0, (cur_date.length - 5)).replace('T', ' ');
    },
    changeActiveMode(payload) {
      this.activeClass = payload.activeClass
        this.main_wrapper = payload.mainWrapperClass
    },
    getMoreResults() {
      this.getCurrencyDetails();
    },

    async getCurrencyDetails(){
      this.$axios.get("getallcurrencies").then((result) => {
        this.currencies = result.data.currencies;
      });
    },

    async enableDisableCurrency(id){
      let result =  await this.$axios.get('enableDisableCurrency?id='+id);
      if(result.data[0]){
        this.$swal({icon:'success',text:"Currency status changed successfully."});
        this.body = '';
      }else{
        this.$swal({icon:'error',text:result.data[1]});
        this.body = '';
      }
      this.getCurrencyDetails();
    }

  },
  async beforeMount() {
    this.getCurrencyDetails();
  },
}
</script>

  
<style scoped>
.income_form {
  background-color: #282828;
  padding: 20px 30px;
  border-radius: 5px;
  box-shadow: #f8f9fa 0px 0px 2px;
}

.box_a {
  background-size: 100% 100%;
  padding: 20px 25px;
  transition: .5s ease-in-out;
  min-height: 145px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.dash-icon.text-orange {
  background: rgba(236, 84, 68, 0.2);
}

.text-orange {
  color: #f86300 !important;
}

.dash-icon {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  margin: 10px auto;
  line-height: 43px;
  position: relative;
  background: #e3e6f9;
  z-index: 1;
  text-align: center;
}

.dash-icon i {
  text-align: center;
  vertical-align: middle;
}

.fs-22 {
  font-size: 22px !important;
}

.dash-icon.text-orange:after {
  background: rgba(236, 84, 68, 0.1);
}

.dash-icon:after {
  position: absolute;
  content: "";
  width: 65px;
  height: 65px;
  border-radius: 50%;
  bottom: 0;
  top: -10px;
  right: 0;
  left: -10px;
  background: rgba(235, 237, 252, 0.4);
  z-index: -1;
}

.dash-icon.text-secondary1 {
  background: rgba(36, 228, 172, 0.2);
}

.text-secondary1 {
  color: #24e4ac !important;
}

.dash-icon.text-secondary1:after {
  background: rgba(36, 228, 172, 0.1);
}

.text-secondary {
  color: #9c52fd !important;
}

.dash-icon.text-secondary:after {
  background: rgb(156 82 253 / 27%);
}

.card {
  background-color: #282828 !important;
  box-shadow: 0px 0px 2px 0px rgb(255 255 255);
}

button.change_wallet
{
    background-color: #ffab46;
    outline: none;
    border: navajowhite;
    padding: 10px 20px;
    color: white;
    border-radius: 7px;
} 

button.block_user
{
    background-color: #ed2713eb;
    outline: none;
    border: navajowhite;
    padding: 10px 20px;
    color: white;
    border-radius: 7px;
}

  button.unBlock_user
{
    background-color: #916044eb;
    outline: none;
    border: navajowhite;
    padding: 10px 20px;
    color: white;
    border-radius: 7px;
  }

</style>
